import { Navigate } from "react-router-dom";
import DesignationList from "../components/designationList";
import DesignationCreate from "../components/designationCreate";
import DesignationEditView from "../components/designationEditView";
import SvgIcons from "../../../../shared/components/svgIcons";
const industryRoute = {
  icon: SvgIcons.MasterDataIcon,
  name: "Master Data",
  link: "/master-datas",
  path: "/master-datas",
  element: "",
  index: 990,
  children: [
    {
      path: "designations",
      element: <DesignationList />,
      name: "Designations",
      permission: "Designation",
      index: 2,
      link: "master-datas/designations",
      icon: SvgIcons.DesignationsIcon,
    },
    {
      path: "designations/create",
      element: <DesignationCreate />,
    },
    {
      path: "designations/:id",
      element: <DesignationEditView />,
    },
    {
      path: "",
      element: <Navigate to="master-datas/designations" replace />,
    },
  ],
};
export default industryRoute;
